export default "__VITE_ASSET__Bl8gyp_r__"